import Cookies from "js-cookie";
import { createContext } from "react";

export const AuthContext = createContext<boolean>(
  Cookies.get("aT") ? true : false
);

export const AuthDispatchContext = createContext<any>(null);

export function authReducer(state: string, action: any) {
  if (action.type === "update") {
    return action.payload
  } else {
    return state
  }
}
